import { motion } from 'framer-motion';
import { FaExternalLinkAlt } from 'react-icons/fa';

const FeaturedProjectCard = ({ project }) => {
  return (
    <motion.a
      href={project.live}
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ y: -8, boxShadow: '0 12px 0 0 rgba(255,255,255,1)' }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
      className="flex flex-col overflow-hidden rounded-2xl border-2 border-white bg-white text-black"
    >
      <div
        className="relative flex h-40 items-center justify-center text-6xl"
        style={{ background: `linear-gradient(135deg, ${project.accentColor}40, ${project.accentColor}10)` }}
      >
        {project.rune}
        <span className="absolute right-3 top-3 flex items-center gap-1.5 rounded-full bg-black px-2.5 py-1 text-xs font-bold text-white">
          <span className="h-1.5 w-1.5 rounded-full bg-green-400" /> LIVE
        </span>
      </div>

      <div className="flex flex-1 flex-col p-5">
        <h3 className="line-clamp-2 min-h-[3.5rem] text-lg font-black leading-tight">{project.title}</h3>
        <p className="mt-2 line-clamp-2 min-h-[2.6rem] text-sm text-black/60">{project.description}</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {project.techStack.map((tech) => (
            <span key={tech} className="rounded-full border border-black/20 px-2 py-0.5 text-xs text-black/60">
              {tech}
            </span>
          ))}
        </div>

        <span className="mt-4 flex items-center gap-1.5 text-sm font-bold">
          Visit site <FaExternalLinkAlt size={11} />
        </span>
      </div>
    </motion.a>
  );
};

export default FeaturedProjectCard;
